import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'
import { cloneDeep } from 'es-toolkit'

const globalSettings: Settings.all = {
  // 请在此处编写或粘贴配置代码
  app: {
    lightTheme: 'green',
    darkTheme: 'green',
    defaultLang: 'zh-cn',
    enableDynamicTitle: true,
    storagePrefix: '2v2a_vcc_',
    enableErrorLog: true,
    enableCheckUpdates: true,
  },
  userPreferences: {
    enable: true,
  },
  layout: {
    enableMobileAdaptation: true,
  },
  menu: {
    mode: 'single',
    style: 'dot',
    subMenuUniqueOpened: false,
    enableHotkeys: true,
  },
  tabbar: {
    style: 'fashion',
    enableIcon: true,
    mergeTabsBy: 'routeName',
    enableMemory: true,
  },
  toolbar: {
    navSearch: false,
    i18n: true,
    fullscreen: true,
    pageReload: true,
    themeScheme: true,
    colorScheme: true,
    layout: [
      'favorites',
      'breadcrumb',
      '->',
      'navSearch',
      'notification',
      'pageReload',
      'colorScheme',
      'fullscreen',
      'i18n',
      'themeScheme',
    ],
  },
  breadcrumb: {
    enableMainMenu: true,
  },
  mainPage: {
    enableHotkeys: false,
    iframeCacheMax: 9,
  },
  navSearch: {
    enableHotkeys: false,
  },
  copyright: {
    enable: true,
    company: '2V2A Digital Technology Limited All Right Reserved.',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
